const isDevelopment =
  process.env.NODE_ENV === 'development' ||
  window.location.hostname === 'localhost';

export const API_BASE_URL = isDevelopment ? 'http://localhost:8081' : '';

export const getApiUrl = (endpoint) => {
  const clean = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${clean}`;
};

export const API = {
  HEALTH: getApiUrl('/api/health'),
  card: (uuid) => getApiUrl(`/api/card/${uuid}`),
  vcard: (uuid) => getApiUrl(`/api/card/${uuid}/vcard`),
  photo: (uuid) => getApiUrl(`/api/card/${uuid}/photo`),
  cardView: (uuid) => getApiUrl(`/api/analytics/card-view/${uuid}`),
};
